module.exports = __webpack_public_path__ + "static/media/Sweef_ride.2f4f5a36.png";